import styled, { css } from 'styled-components';

export const TotalCharge = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.gray.extraLight};
  `};
`;
